"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Collapse_1 = __importDefault(require("react-bootstrap/Collapse"));
var icon_library_enum_1 = __importDefault(require("../../shared/enums/icon-library.enum"));
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var shades_enum_1 = __importDefault(require("../../shared/enums/shades.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var button_icon_1 = __importDefault(require("../button-icon"));
require("./drawer.scss");
function Drawer(props) {
    var _a = (0, react_1.useState)(props.open), open = _a[0], setOpen = _a[1];
    var isOpen = function () { return (props.open !== undefined ? props.open : open); };
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("mpng-ux-drawer position-fixed top-0 shadow-sm", props.right ? "right-0" : "left-0", props.className) },
        // show toggle by default (when undefined)
        (props.showToggle || props.showToggle === undefined) && (react_1.default.createElement(button_icon_1.default, { callback: function () { return setOpen(!open); },
            priority: shades_enum_1.default.LIGHT,
            icon: {
                library: icon_library_enum_1.default.LIGHT,
                icon: (!props.right && !isOpen()) || (props.right && isOpen())
                    ? icon_enum_1.default.CHEVRON_RIGHT
                    : icon_enum_1.default.CHEVRON_LEFT
            },
            className: (0, classMap_1.default)("drawer-toggle mt-5 py-3", "position-absolute top-0", "animation shadow-hover", "bg-white z-index--1", props.right ? "right pe-3 ps-2" : "left pe-2 ps-3", props.className) })),
        react_1.default.createElement(Collapse_1.default, { in: isOpen(), dimension: "width" },
            react_1.default.createElement("div", { className: "animation" },
                react_1.default.createElement("div", { className: (0, classMap_1.default)("bg-light vh-100 p-3", "size ".concat(props.size || "sm")) }, props.child)))));
}
exports.default = Drawer;
